import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { DbtRefresh } from '@tdf/rtpca-models';

@Injectable({
  providedIn: 'root',
})
export class DbtRunnerService {
  private readonly http = inject(HttpClient);

  private readonly refreshApi = `${environment.baseUrl}` + '/track-refresh';

  getRuntimeStatus() {
    return this.http.get<DbtRefresh[]>(this.refreshApi);
  }

}
